

































import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData, UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "UserBadgeWithAvatar",
  components: { BaseAvatar },
  props: {
    user: { type: Object as PropType<UserPublicData | UserWithAvatar>, required: true },
    subtitle: { type: String },
    to: { type: Object as PropType<Location> },
    clickableName: { type: Boolean, default: false },
    clickableAvatar: { type: Boolean, default: false },
    size: { type: [Number, String], default: 112 },
    small: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
  },
  setup() {
    return {
      getProfileUrl,
    };
  },
});
